// File: components/workWithLeadership/WorkWithLeadership.jsx

import React from "react";
import "./WorkWithLeadership.css";
import { useNavigate } from "react-router-dom";

import leadershipImage from "../../Assets/images/books1.jpeg";

export default function WorkWithLeadership() {

  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/contact-us");
  };

  return (

    <section className="work-leadership-section">

      <div className="work-leadership-container">

        {/* Left Image */}
        <div className="work-leadership-image-wrapper">

          <img
            src={leadershipImage}
            alt="Ample Leadership"
            className="work-leadership-image"
          />

        </div>

        {/* Right Content */}
        <div className="work-leadership-content">

          <h2>
            Working with Ample Publications
          </h2>

          <p>
            Turn your ideas into a compelling,
            well-structured manuscript with our
            expert guidance.
          </p>

          <button
            className="work-leadership-btn"
            onClick={handleNavigate}
          >
            Learn More
          </button>

        </div>

      </div>

    </section>

  );
}